<template>
    <div class="AdminSettingsPage">
        <DashboardSectionHeader title="Settings"/>
        <OwnerForm/>
        <CompanyForm :company="company"/>
        <SubscriptionView/>
    </div>
</template>


<script>
import { mapState } from 'vuex';
import * as api from '@/api';
import DashboardSectionHeader from '@/components/DashboardSectionHeader';
import DashboardEditSection from '@/components/DashboardEditSection';
import SubscriptionView from './components/SubscriptionView';
import OwnerForm from './components/OwnerForm';
import CompanyForm from '../settings/components/CompanyForm.vue';

export default {
    name: 'AdminSettingsPage',

    components: {
        DashboardSectionHeader,
        DashboardEditSection,
        SubscriptionView,
        OwnerForm,
        CompanyForm,
    },

    data: () => ({
        company: null,
    }),

    computed: mapState('auth', ['user']),

    mounted() {
        this.fetchCompany();
    },

    methods: {
        async fetchCompany() {
            const companyId = this.$store.getters['auth/company'].id;
            this.fetchPending = true;
            const res = await api.getCompany(companyId);
            this.fetchPending = false;

            if (res.error) {
                this.fetchError = res.error;
                return this.$awn.alert('Failed to fetch company');
            }

            this.company = res.body;
            this.$store.dispatch('auth/setAdminCompany', res.body);
        },
    },
};
</script>


<style lang="scss" scoped>
.AdminSettingsPage {
    .toggleRow {
        display: flex;
        justify-content: space-between;
        align-items: center;

        &:not(:last-child) {
            margin-bottom: 15px;
        }
    }
}
</style>
